import { render, staticRenderFns } from "./MotorApprovedProposal.vue?vue&type=template&id=5f4ab2fa&"
import script from "./MotorApprovedProposal.vue?vue&type=script&lang=js&"
export * from "./MotorApprovedProposal.vue?vue&type=script&lang=js&"
import style0 from "./MotorApprovedProposal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "MotorApprovedProposal.vue"
export default component.exports